import { put, call } from "redux-saga/effects";
import log from "loglevel";
import * as services from "./service";
import * as types from "./types";
import * as actions from "./action";
import { toastr } from "react-redux-toastr";

export function* getPermissionsSaga(action: types.GetPermissionsActionType) {
  try {
    const response = yield call(services.getPermissionsService);
    yield put({ type: actions.GET_PERMISSIONS_SUCCESS, response });
  } catch (error) {
    yield put({ type: actions.GET_PERMISSIONS_ERROR, response: error });
  }
}

export function* getRolePermissionsSaga(
  action: types.GetRolePermissionsActionType
) {
  try {
    const response = yield call(services.getRolePermissionsService);
    yield put({ type: actions.GET_ROLEPERMISSIONS_SUCCESS, response });
  } catch (error) {
    yield put({ type: actions.GET_ROLEPERMISSIONS_ERROR, response: error });
  }
}

export function* getRolesSaga(action: types.GetRolesActionType) {
  try {
    const response = yield call(services.getRolesService);
    yield put({ type: actions.GET_ROLES_SUCCESS, response });
  } catch (error) {
    yield put({ type: actions.GET_ROLES_ERROR, response: error });
  }
}
